import {useQuery} from '@tanstack/react-query';
import {BOARD_QUERY_KEY} from './queryKeys';
import {getFavoriteState} from '@/api/channel/board';

export const useFavoriteQuery = (userId: string) => {
  return useQuery({
    queryKey: BOARD_QUERY_KEY.FAVORITE(userId),
    queryFn: () => getFavoriteState({userId}),
    enabled: false,
  });
};
